export default __webpack_public_path__ + "static/media/open-sans-latin-700italic.e961bdb4.woff";